<div *ngIf="loaded && movie; else loading" [id]="template" [class]="[movie?.friendlyUrl]">
  <ng-container *ngTemplateOutlet="templateRef"></ng-container>
</div>

<ng-template #loading>
  <div>
    <ush-loading-indicator
      [style.height]="'100%'"
      [aligning]="'absolute-center'"
      height="75vh"
      fontSize="50px"
    ></ush-loading-indicator>
  </div>
</ng-template>

<!-- Horizontal (default) Template -->
<ng-template #horizontal>
  <div class="movie-template-b horizontal-template">
    <ng-container [ngTemplateOutlet]="competitionBannerTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="menuBrandedTemplate"></ng-container>

    @if (menuTrailerCustomTemplate) {
      <ng-container *ngTemplateOutlet="menuTrailerCustomTemplate" />
    }

    <!-- HOME TAB -->
    <ng-template #home1Tab>
      <div class="home-container" @fadeIn>
        <div class="noMaxWidth video-thumbnail-container">
          <ush-feature-movie-hero
            [movie]="movie"
            [logoSizes]="logoSizes"
            [hideWatchNowCtaButton]="hideWatchNowCtaButton"
          />

          <ng-container *ngIf="beforeReleaseBookBtnCustom && (locReleaseDate$ | async) < today"></ng-container>

          <ng-container *ngTemplateOutlet="beforeReleaseBookCustom" />
        </div>
      </div>
    </ng-template>
    <!-- HOME TAB -->

    <!-- SHOWTIMES TAB -->
    <ng-template #showtimesTab>
      <div class="showtimes-container" @fadeIn>
        <!-- POSTER -->
        <div class="poster" #poster>
          <img
            [alt]="movie?.title + ' poster image'"
            *ngIf="movie.portraitPhotoUrl"
            [src]="movie.portraitPhotoUrl | img: { width: 500 }"
            [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }"
            addSkeleton
          />
          <ush-movie-tell-friends [movie]="movie"></ush-movie-tell-friends>
        </div>
        <div class="ush-showtime-streaming-in-cinemas--container">
          <div
            class="special-text"
            [innerHTML]="'branded-page_showtimes-special-text' | translate: { placeholder: '' } | safe: 'html'"
            [attr.data-translate]="'branded-page_showtimes-special-text'"
          ></div>
          <ush-showtime-streaming-in-cinemas [movie]="movie" />
        </div>
      </div>
    </ng-template>
    <!-- SHOWTIMES TAB -->

    <!-- STREAMING TAB -->
    <ng-template #streamingTab>
      <div class="stremaing-container" @fadeIn>
        <ush-showtime-streaming-watch-at-home
          [movie]="movie"
          (streamingPlatformsLoaded)="onStreamingPlatformsLoaded(movie)"
        />
      </div>
    </ng-template>
    <!-- STREAMING TAB -->

    <!-- GALLERY TAB -->
    <ng-template #galleryTab>
      <div class="gallery">
        <feature-gallery-carousel
          [images]="movie.movieImages"
          [arrowTemplate]="6"
          [slidesPerView]="getHorizontalGallerySwiperConfig()"
        />
      </div>
    </ng-template>
    <!-- GALLERY TAB -->

    <!-- TRAILER TAB -->
    <ng-template #trailerPageTab>
      <div class="trailer-page-container" @fadeIn>
        <div class="trailer-container">
          <ush-feature-movie-hero [movie]="movie" [logoSizes]="logoSizes" />
        </div>
      </div>
    </ng-template>
    <!-- TRAILER TAB -->

    <!-- SYNOPSIS TAB -->
    <ng-template #synopsisTab>
      <div class="synopsis-container" @fadeIn>
        <ng-container *ngIf="synopsisTopAddon">
          <ng-container [ngTemplateOutlet]="synopsisTopAddon"></ng-container>
        </ng-container>
        <div class="synopsis-wrapper">
          <ush-movie-synopsis [movie]="movie"></ush-movie-synopsis>
          <div class="alternative-info-layout-2">
            <div class="info" [class.compacted]="!infoExpanded && compactInfo">
              <!-- CREDITS-->
              <ush-movie-credits [movie]="movie"></ush-movie-credits>
              <!-- MORE INFORMATION-->
              <ush-movie-more-information
                [movie]="movie"
                class="main"
                [titleAsLink]="customMovie?.movieInformationTitleAsLink"
                [showTPAffinity]="customMovie?.filmAffinity"
              ></ush-movie-more-information>
            </div>
            <see-more *ngIf="compactInfo" (clicked)="infoExpanded = !infoExpanded" [expanded]="infoExpanded"></see-more>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- SYNOPSIS TAB -->

    <div class="main">
      @switch (tab) {
        @case ('home') {
          <ng-container *ngTemplateOutlet="home1Tab" />
        }
        @case ('showtimes') {
          <ng-container *ngTemplateOutlet="showtimesTab" />
        }
        @case ('streaming') {
          <ng-container *ngTemplateOutlet="streamingTab" />
        }
        @case ('gallery') {
          <ng-container *ngTemplateOutlet="galleryTab" />
        }
        @case ('trailerPage') {
          <ng-container *ngTemplateOutlet="trailerPageTab" />
        }
        @case ('synopsis') {
          <ng-container *ngTemplateOutlet="synopsisTab" />
        }
      }
    </div>

    <div class="main main-assistant">
      <ng-container *ngTemplateOutlet="home1Tab" />

      <ng-container *ngIf="beforeReleaseBookBtnCustom && (locReleaseDate$ | async) < today">
        <ng-container *ngTemplateOutlet="beforeReleaseBookCustom" />
      </ng-container>

      @if (!hidenTabs?.includes('in-cinemas') && showtimesAvailable) {
        <div id="showtimes" class="header-msg title" i18n="in-cinemas" data-translate="in-cinmeas">Showtimes</div>
        <ng-container *ngTemplateOutlet="showtimesTab" />
      }
      @if (!hidenTabs.includes('watch-at-home') && streamingAvailable) {
        <div class="header-msg title" i18n="watch-at-home" data-translate="watch-at-home">Watch at Home</div>
        <ng-container *ngTemplateOutlet="streamingTab" />
      }

      <ng-container *ngTemplateOutlet="synopsisTab" />
      @if (movie?.movieImages || movie?.moviePosters) {
        <ng-container *ngTemplateOutlet="galleryTab" />
      }

      <ng-container *ngTemplateOutlet="trailerPageTab" />
    </div>

    <!-- copyright -->
    <ng-container *ngTemplateOutlet="copyright" />
  </div>
</ng-template>

<!-- Vertical Template -->
<ng-template #vertical>
  <ng-container *ngIf="topBanner" [ngTemplateOutlet]="topBannerTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="competitionBannerTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="menuBrandedTemplate"></ng-container>
  <div class="main textColor">
    <div class="content-wrapper">
      <div id="trailer" class="trailer" #trailer>
        <div class="noMaxWidth video-thumbnail-container">
          <ush-feature-movie-hero
            [movie]="movie"
            [logoSizes]="logoSizes"
            [hideWatchNowCtaButton]="hideWatchNowCtaButton"
          />
        </div>
      </div>

      <ng-container *ngIf="trailerInMenu">
        <ng-container *ngIf="menuTrailerCustomTemplate; else watchTrailer">
          <ng-container *ngTemplateOutlet="menuTrailerCustomTemplate"></ng-container>
        </ng-container>
      </ng-container>
      <div class="page-content branded-content">
        <div class="movie-detail-container">
          <!-- SHOWTIMES SECTION -->
          <div id="showtimes" class="showtimes">
            <div class="padding">
              <!-- POSTER -->
              <div class="poster" #poster>
                <img
                  [alt]="movie?.title + ' poster image'"
                  *ngIf="movie.portraitPhotoUrl"
                  [src]="movie.portraitPhotoUrl | img: { width: 500 }"
                  [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }"
                />
                <ush-movie-tell-friends [movie]="movie"></ush-movie-tell-friends>
              </div>
              <!-- SHOWTIME -->
              <div class="showtime-element" *ngIf="!disableShowtimes">
                <ush-showtime-streaming
                  @fadeIn
                  [movie]="movie"
                  [inCinemasAddon]="brandedInCinemasAddon"
                  [hideTabs]="customMovie.hideTabs"
                  [customSubscribeTitleTr]="customSubscribeMessage"
                ></ush-showtime-streaming>
                <div class="asset-locker-holder">
                  <!-- ASSETS LOCKER -->
                  <ush-assets-locker-link *ngIf="movie?.hasAssets" [movie]="movie"></ush-assets-locker-link>
                </div>
              </div>
            </div>
          </div>
          <!-- ABOUT SECTION -->
          <div class="about">
            <div class="padding">
              <ng-container
                [ngTemplateOutlet]="alternativeAboutLayout"
                [ngTemplateOutletContext]="{ $implicit: customMovie.alternativeAboutLayout }"
              >
              </ng-container>

              <ng-template #alternativeAboutLayout let-layout>
                <ng-container [ngSwitch]="layout">
                  <ng-container *ngSwitchCase="1">
                    <div class="alternative-about-layout-1">
                      <!-- ABOUT-->
                      <ush-movie-synopsis id="about" [movie]="movie"></ush-movie-synopsis>
                      <!-- CREDITS-->
                      <ush-movie-credits [movie]="movie"></ush-movie-credits>
                    </div>
                    <!-- MORE INFORMATION-->
                    <ush-movie-more-information
                      [movie]="movie"
                      class="main"
                      [titleAsLink]="customMovie?.movieInformationTitleAsLink"
                      [showTPAffinity]="customMovie?.filmAffinity"
                    ></ush-movie-more-information>
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <div class="alternative-about-layout-2">
                      <!-- ABOUT-->
                      <div id="about" class="synopsis-wrapper">
                        <ush-movie-synopsis [movie]="movie"></ush-movie-synopsis>
                        <ng-container *ngIf="customElements?.synopsis">
                          <div
                            class="synopsis-custom-element"
                            [innerHTML]="customElements?.synopsis | safe: 'html'"
                          ></div>
                        </ng-container>
                        <ush-movie-reasons-to-watch
                          id="reasonsToWatch"
                          *ngIf="movie.trReasonsToWatch && customMovie.reasonsToWatchLayout === 2"
                          [movie]="movie"
                          [header]="customMovie?.customTranslations?.reasonsToWatch"
                        ></ush-movie-reasons-to-watch>
                      </div>

                      <div class="alternative-info-layout-2">
                        <div class="info" [class.compacted]="!infoExpanded && compactInfo">
                          <!-- CREDITS-->
                          <ush-movie-credits [movie]="movie"></ush-movie-credits>
                          <!-- MORE INFORMATION-->
                          <ush-movie-more-information
                            [movie]="movie"
                            class="main"
                            [titleAsLink]="customMovie?.movieInformationTitleAsLink"
                            [showTPAffinity]="customMovie?.filmAffinity"
                          ></ush-movie-more-information>

                          <ng-container *ngIf="customElements?.layout2">
                            <div
                              class="layout-2-custom-element"
                              [innerHTML]="customElements?.layout2 | safe: 'html'"
                            ></div>
                          </ng-container>
                        </div>
                        <see-more
                          *ngIf="compactInfo"
                          (clicked)="infoExpanded = !infoExpanded"
                          [expanded]="infoExpanded"
                        ></see-more>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <!-- ABOUT-->
                    <ush-movie-synopsis id="about" [movie]="movie"></ush-movie-synopsis>
                    <!-- CREDITS-->
                    <ush-movie-credits [movie]="movie"></ush-movie-credits>
                    <!-- MORE INFORMATION-->
                    <ush-movie-more-information
                      [movie]="movie"
                      class="main"
                      [titleAsLink]="customMovie?.movieInformationTitleAsLink"
                      [showTPAffinity]="customMovie?.filmAffinity"
                    ></ush-movie-more-information>
                  </ng-container>
                </ng-container>
              </ng-template>

              <ng-template #alternativeAboutLayout2>
                <div class="alternative-about-layout-2">
                  <!-- ABOUT-->
                  <div>
                    <ush-movie-synopsis [movie]="movie"></ush-movie-synopsis>
                    <ush-movie-reasons-to-watch
                      id="reasonsToWatch"
                      *ngIf="movie.trReasonsToWatch && customMovie.reasonsToWatchLayout === 2"
                      [movie]="movie"
                      [header]="customMovie?.customTranslations?.reasonsToWatch"
                    ></ush-movie-reasons-to-watch>
                  </div>

                  <div class="movie-data">
                    <!-- CREDITS-->
                    <ush-movie-credits [movie]="movie"></ush-movie-credits>
                    <!-- MORE INFORMATION-->
                    <ush-movie-more-information
                      [movie]="movie"
                      class="main"
                      [titleAsLink]="customMovie?.movieInformationTitleAsLink"
                      [showTPAffinity]="customMovie?.filmAffinity"
                    ></ush-movie-more-information>
                  </div>
                </div>
              </ng-template>
              <ush-movie-tell-friends class="social-share-movie-more-info" [movie]="movie"></ush-movie-tell-friends>

              <!-- REASONS TO WATCH -->
              <ush-movie-reasons-to-watch
                id="reasonsToWatch"
                *ngIf="
                  movie.trReasonsToWatch &&
                  (customMovie.reasonsToWatchLayout === 1 || !customMovie.reasonsToWatchLayout)
                "
                [movie]="movie"
                [header]="customMovie?.customTranslations?.reasonsToWatch"
              ></ush-movie-reasons-to-watch>
              <!-- SOCIAL NETWORKS -->
              <ng-container *ngIf="movie.socialNetworks">
                <div id="mobile-social-links" class="social-links">
                  <ush-social-links [socialNetworks]="movie.socialNetworks"></ush-social-links>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- FESTIVALS -->
        <div id="festivals" class="festivals-wrapper" *ngIf="festivalsEnabled && festivals?.length > 0">
          <div class="header-msg title" [attr.data-translate]="'movie.menu.festivals'">
            {{ 'movie.menu.festivals' | translate }}
          </div>
          <ush-feature-laurels-carousel [laurels]="festivals"></ush-feature-laurels-carousel>
        </div>

        <ng-container *ngIf="hasReviews">
          <ush-movie-reviews id="reviews" [movie]="movie"></ush-movie-reviews>
        </ng-container>

        <!-- REASONS TO WATCH -->
        <ush-movie-reasons-to-watch
          id="reasonsToWatch"
          *ngIf="movie.trReasonsToWatch && customMovie.reasonsToWatchLayout === 3"
          [movie]="movie"
          [header]="customMovie?.customTranslations?.reasonsToWatch"
        ></ush-movie-reasons-to-watch>

        <!-- EXTRA SECTION -->
        <ng-container *ngIf="extraContent">
          <ng-container *ngFor="let content of extraContent">
            <ng-container *ngIf="content.type === 'custom-movie'">
              <div [id]="$any(content.module)?.name">
                <ng-container [ngTemplateOutlet]="$any(content.module)?.contentTemplate"></ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="content.type === 'channel'">
              <div [id]="$any(content.module)?.title">
                <div [innerHTML]="$any(content.module)?.content | safe: 'html'"></div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- VIDEOS GALLERY -->
        <div id="videos" class="videos-wrapper" *ngIf="movie.movieVideos?.length > 0">
          <div class="videos slider-external-wrapper" pDefer (onLoad)="onDisplayComponent('videos')">
            <ng-template>
              <div #video class="content-videos slider-container" [ngClass]="displayVideos ? 'visible-on-scroll' : ''">
                <ush-feature-videos-carousel [videos]="movie.movieVideos"></ush-feature-videos-carousel>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- IMAGES GALLERY -->
        <div id="gallery" class="gallery-wrapper" *ngIf="movie.movieImages?.length > 0">
          <div class="slider-external-wrapper" (onLoad)="onDisplayComponent('gallery')" pDefer>
            <ng-template>
              <div #gallery class="slider-container" [ngClass]="displayGallery ? 'visible-on-scroll' : ''">
                <feature-gallery-carousel
                  [images]="movie.movieImages"
                  [arrowTemplate]="arrowTemplate"
                  [hideArrows]="hideArrows"
                ></feature-gallery-carousel>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- POSTERS GALLERY -->
        <div id="posters" class="posters-wrapper" *ngIf="movie.moviePosters?.length > 0">
          <div class="posters slider-external-wrapper" (onLoad)="onDisplayComponent('posters')" pDefer>
            <ng-template>
              <div #posters class="slider-container" [ngClass]="displayPosters ? 'visible-on-scroll' : ''">
                <feature-gallery-carousel
                  [images]="movie.movieImages"
                  [imageOrientation]="'portrait'"
                  [arrowTemplate]="arrowTemplate"
                ></feature-gallery-carousel>
              </div>
            </ng-template>
          </div>
        </div>
        <div id="wallpaper" *ngIf="desktopWallpapers?.enabled || mobileWallpapers?.enabled"></div>
        <!-- DESKTOP WALLPAPERS -->
        <div class="wallpaper-desktop-wrapper" *ngIf="desktopWallpapers?.enabled">
          <ng-container
            [ngTemplateOutlet]="wallpaper"
            [ngTemplateOutletContext]="{ $implicit: desktopWallpapers }"
          ></ng-container>
        </div>
        <!-- MOBILE WALLPAPERS -->
        <div class="wallpaper-mobile-wrapper" *ngIf="mobileWallpapers?.enabled">
          <ng-container
            [ngTemplateOutlet]="wallpaper"
            [ngTemplateOutletContext]="{ $implicit: mobileWallpapers }"
          ></ng-container>
        </div>

        <!-- CHANNEL SOCIAL FEED -->
        <div id="socialFeed" class="social-feed-wrapper" *ngIf="customMovie.channelSocialFeed && socialFeedFound">
          <div (onLoad)="onDisplayComponent('socialFeed')" pDefer>
            <ng-template>
              <div class="header-msg title" [attr.data-translate]="'movie.menu.socialFeed'">
                {{ 'movie.menu.socialFeed' | translate }}
              </div>
              <ush-social-feed
                *ngIf="customMovie.channelSocialFeed"
                (socialFeedFound)="socialFeedFound = $event"
              ></ush-social-feed>
            </ng-template>
          </div>
        </div>
        @if (movie.newsPosts?.length) {
          @defer (on viewport) {
            <community-feature-news-carousel
              [news]="movie.newsPosts"
              newsSubtitle=""
              viewAllLink=""
            ></community-feature-news-carousel>
          } @placeholder {
            <div>This is news placeholder</div>
          }
        }
        <!-- CONTACT -->
        <div id="contact" class="contact-wrapper" *ngIf="customMovie.contact">
          <div class="header-msg title" [attr.data-translate]="'movie.menu.contact'">
            {{ 'movie.menu.contact' | translate }}
          </div>
          <a href="" class="contact" [href]="'mailto:' + customMovie.contact">{{ customMovie.contact }}</a>
        </div>

        <div *ngIf="movie.copyrightImage" id="copyright">
          <div class="padding" (onLoad)="onDisplayComponent('copyright')" pDefer>
            <ng-template>
              <img [src]="movie.copyrightImageUrl | img" [alt]="'copyright ' + movie.title" />
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #topBannerTemplate>
  <div class="top-banner">
    <div [innerHTML]="topBanner.content | safe: 'html'"></div>
  </div>
</ng-template>

<ng-template #competitionBannerTemplate>
  <div
    *ngIf="competitionBanner && hasCompetitions && !hideCompetitionBtn"
    class="competitions-button-container"
    [ngClass]="{ hideCompetitions: hideCompetitionBtn }"
  >
    <div class="competitions-wrapper">
      <a class="competitions-button" (click)="competitionSelected()" [routerLink]="competitionBanner">
        <ng-container *ngIf="customCompetitionCta; else defaultBannerCta">
          {{ customCompetitionCta || 'video-thumbnail.competition' | translate }}
        </ng-container>
      </a>
      <fa-icon [icon]="faTimes" (click)="hideCompetitionBtn = true"></fa-icon>
    </div>
  </div>
</ng-template>

<ng-template #defaultBannerCta>
  {{ 'video-thumbnail.competition' | translate }}
  <span class="highlight">{{ movie?.title }}</span>
</ng-template>

<ng-template #menuBrandedTemplate>
  <div class="menu-container">
    <div
      class="menu brandBg"
      [ngClass]="{ 'menu-competition': competitionBanner && hasCompetitions && !hideCompetitionBtn }"
      @fadeIn
    >
      <ng-container *ngIf="getMovieMenuGetTicketOrStreamingKey() as menuKey">
        <a
          class="bold link-box"
          [ngClass]="{ highlight: tab === 'showtimes' }"
          *ngIf="!hidenTabs?.includes('in-cinemas') && showtimesAvailable"
          (click)="goTo('showtimes')"
          [attr.data-translate]="menuKey"
          >{{ menuKey | translate }}</a
        >
      </ng-container>

      @if (movieMenuExtraElements) {
        <ng-container *ngTemplateOutlet="movieMenuExtraElements" />
      }
      <nav>
        <ul>
          <li class="app-home" *ngIf="logoInMenu">
            <a class="bold" [routerLink]="['/']">
              <img id="logo" [src]="appLogoUrl | img: appLogoParams" alt="logo" />
            </a>
          </li>
          <li class="menu-home" *ngIf="homeInMenu" class="home-menu" [ngClass]="{ highlight: tab === 'home' }">
            <a class="bold" (click)="goTo('home')" [attr.data-translate]="'movie.menu.home'">{{
              'movie.menu.home' | translate
            }}</a>
          </li>
          <li
            class="menu-trailer trailer-menu"
            *ngIf="trailerInMenu && movie.trailerLink"
            [ngClass]="{ highlight: tab === 'trailerPage' }"
          >
            <fa-icon [icon]="faPlay"></fa-icon>
            <a class="bold" (click)="goTo('trailerPage')" [attr.data-translate]="'movie.menu.trailer'">{{
              'movie.menu.trailer' | translate
            }}</a>
          </li>
          <li class="menu-reasonsToWatch" *ngIf="movie?.trReasonsToWatch">
            <a class="bold" (click)="goTo('reasonsToWatch')" [attr.data-translate]="'movie.menu.reasonsToWatch'"
              ><span>{{ 'movie.menu.reasonsToWatch' | translate }}</span></a
            >
          </li>
          <li class="menu-about" [ngClass]="{ highlight: tab === 'synopsis' || tab === 'about' }">
            <a
              *ngIf="customMovie.template === 'vertical'"
              class="bold"
              (click)="goTo('about')"
              [attr.data-translate]="'movie.menu.about'"
              >{{ 'movie.menu.about' | translate }}</a
            >
            <a
              *ngIf="customMovie.template === 'horizontal'"
              class="bold"
              (click)="goTo('synopsis')"
              [attr.data-translate]="'movie.menu.synopsis'"
              >{{ 'movie.menu.synopsis' | translate }}</a
            >
          </li>
          <li class="menu-festivals" *ngIf="customMovie.festivals" [ngClass]="{ highlight: tab === 'festivals' }">
            <a class="bold" (click)="goTo('festivals')">
              <span>{{ 'movie.menu.festivals' | translate }}</span>
            </a>
          </li>
          <li
            class="menu-streaming"
            *ngIf="!hidenTabs?.includes('watch-at-home') && streamingAvailable"
            [ngClass]="{ highlight: tab === 'streaming' }"
          >
            <a class="bold" (click)="goTo('streaming')">
              <span>{{ 'movie.menu.watch-at-home' | translate }}</span>
            </a>
          </li>
          <li
            class="menu-reviews"
            [ngClass]="{ highlight: tab === 'reviews' }"
            *ngIf="!hidenTabs?.includes('reviews') && movie.reviews"
          >
            <a class="bold" (click)="goTo('reviews')" [attr.data-translate]="'movie.menu.reviews'">{{
              'movie.menu.reviews' | translate
            }}</a>
          </li>
          <li class="menu-video" *ngIf="movie.movieVideos" [ngClass]="{ highlight: tab === 'videos' }">
            <a class="bold" (click)="goTo('videos')" [attr.data-translate]="'movie.menu.video'">{{
              'movie.menu.video' | translate
            }}</a>
          </li>
          <li
            class="menu-gallery"
            *ngIf="movie?.movieImages || movie?.moviePosters"
            [ngClass]="{ highlight: tab === 'gallery' }"
          >
            <a class="bold" (click)="goTo('gallery')">{{ 'movie.menu.gallery' | translate }}</a>
          </li>
          <li
            class="menu-wallpaper"
            *ngIf="desktopWallpapers?.enabled || mobileWallpapers?.enabled"
            [ngClass]="{ highlight: tab === 'wallpaper' }"
          >
            <a class="bold" (click)="goTo('wallpaper')">
              <span>{{ 'movie.menu.wallpaper' | translate }}</span>
            </a>
          </li>
          <li
            class="menu-socialFeed"
            *ngIf="customMovie.channelSocialFeed && socialFeedFound"
            [ngClass]="{ highlight: tab === 'socialFeed' }"
          >
            <a class="bold" (click)="goTo('socialFeed')">
              <span>{{ 'movie.menu.socialFeed' | translate }}</span>
            </a>
          </li>
          <li class="menu-contact" *ngIf="customMovie.contact" [ngClass]="{ highlight: tab === 'contact' }">
            <a class="bold" (click)="goTo('v')">
              <span>{{ 'movie.menu.contact' | translate }}</span>
            </a>
          </li>
          <li *ngIf="hasCompetitions && !competitionBanner && !hideCompetition">
            <a
              class="bold"
              (click)="competitionSelected()"
              [routerLink]="['/competitions', movie.id]"
              [attr.data-translate]="'movie.menu.competitions'"
              >{{ 'movie.menu.competitions' | translate }}</a
            >
          </li>
          <li
            *ngFor="let extraTab of extraTabs"
            class="tab-{{ extraTab.key }}"
            [ngClass]="{ highlight: tab === extraTab.key }"
          >
            <ng-container *ngIf="extraTab.function">
              <a class="bold" (click)="extraTab.function(this)" [attr.data-translate]="extraTab.key">{{
                extraTab.key | translate
              }}</a>
            </ng-container>
            <ng-container *ngIf="!extraTab.function">
              <a
                class="bold"
                [routerLink]="extraTab.url"
                (click)="extraTab.extraSection ? goTo(extraTab.extraSection) : ''"
                [externalLink]="isExternalLink(extraTab.url) ? extraTab.url : ''"
                [attr.data-translate]="extraTab.key"
                >{{ extraTab.key | translate }}</a
              ></ng-container
            >
          </li>
          <li class="menu-language-selector"></li>
        </ul>
      </nav>
      <ng-container *ngIf="channelSocialNetworks">
        <div *ngIf="channel.socialNetworks" id="browser-social-links" class="social-links">
          <ush-social-links [socialNetworks]="channel.socialNetworks" [movie]="movie"></ush-social-links>
        </div>
      </ng-container>
      <ng-container *ngIf="!channelSocialNetworks">
        <div *ngIf="movie.socialNetworks" id="browser-social-links" class="social-links">
          <ush-social-links [socialNetworks]="movie.socialNetworks" [movie]="movie"></ush-social-links>
          <!--        <app-link-007 *ngIf="movie.title == 'No Time to Die'"></app-link-007>-->
        </div>
      </ng-container>

      <ng-container *ngIf="customMovie.langSelectorInMenu">
        <ush-language-selector></ush-language-selector>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #copyright>
  <div *ngIf="movie.copyrightImage" id="copyright">
    <div class="padding">
      <img [src]="movie.copyrightImageUrl | img" [alt]="'copyright ' + movie.title" />
    </div>
  </div>
</ng-template>

<ng-template #watchTrailer>
  <div class="menu-trailer-vertical" (click)="playTrailer()">
    <a
      class="bold"
      [attr.data-translate]="'movie.menu.trailer'"
      *ngIf="!hidenTabs?.includes('in-cinemas') && showtimesAvailable"
      >{{ 'movie.menu.trailer' | translate }}</a
    >
    <fa-icon [icon]="faPlay"></fa-icon>
  </div>
</ng-template>

<ng-template #wallpaper let-wallpaperSetting>
  <div
    id="wallpaper-{{ wallpaperSetting.orientation === 'landscape' ? 'desktop' : 'mobile' }}"
    *ngIf="wallpaperSetting.imgList?.length > 0"
    (onLoad)="onDisplayComponent('wallpaper')"
    pDefer
  >
    <ng-template>
      <div
        #gallery
        class="slider-container wallpaper slider-external-wrapper"
        [ngClass]="displayGallery ? 'visible-on-scroll' : ''"
      >
        <swiper-container
          ushSwiperElement
          [config]="getWallpaperSwiperConfig(wallpaperSetting.orientation)"
          init="false"
        >
          <swiper-slide *ngFor="let imgUrl of wallpaperSetting.imgList" lazy="true">
            <img
              customClass="img-bg"
              [ngSrc]="imgUrl"
              [sizes]="wallpaperSetting.sizes"
              fill="true"
              style="height: auto; width: 100%; position: relative"
              [alt]="'wallpaper for ' + wallpaperSetting?.orientation"
              [modal]="{ src: imgUrl, type: wallpaperSetting.orientation, movie: movie, imgType: 'wallpaper-img' }"
            />
            <fa-icon [icon]="faDownload" size="lg"></fa-icon>
          </swiper-slide>
        </swiper-container>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #beforeReleaseBookCustom>
  @if (beforeReleaseBookBtnCustom) {
    <div class="custom-book">
      @for (link of beforeReleaseBookBtnCustom; track link.id) {
        @if (link.url) {
          <a class="button p-button" [href]="link.url | safe: 'url'" target="_blank">
            <ng-container *ngTemplateOutlet="content; context: { $implicit: link }" />
          </a>
        } @else {
          <a class="button p-button" (click)="goTo('showtimes')">
            <ng-container *ngTemplateOutlet="content; context: { $implicit: link }" />
          </a>
        }
      }
    </div>

    <ng-template #content let-link>
      @if (link.text) {
        <span [attr.date-translate]="link.text">{{ link.text | translate }}</span>
      } @else {
        <span data-translate="book" i18n="book">Book</span>&nbsp;{{ link.date | date: 'dd/MM' }}
      }
    </ng-template>
  }
</ng-template>
